/**
 * Configuración de TEST
 * Reemplaza a environment.ts cuando se compila con:  ng build -c test
 */
export const environment = {
    production: false,
    envName: 'test',
    theme: 'default',
    category_include: [] as string[],
    category_exclude: ['rock'] as string[],

    // ── API ────────────────────────────────────────────────
    api: {
        logEnabled: true,
        baseUrl: 'https://api.ticketexitotest.apps-ecualatino.dev/web',
        api_key: '0f0b7b0e77a124aff9ee4c5ada355708dee181045aeed3d45941fd5ff69270c6',
        cookie_http_only: true,
        allowSafariTokenFallback: true,
        logoUrl: '',
        seo: {
            siteName: 'TicketExito',
            title: 'TicketExito - Compra tickets para eventos en Ecuador',
            description: 'Compra tus entradas para eventos, conciertos y espectáculos en Ecuador de forma segura y rápida.',
            keywords: 'tickets, eventos, Ecuador, entradas, conciertos, espectáculos',
            url: 'https://ticketexito.ec/',
            image: 'https://ticketexito-public.s3.us-east-1.amazonaws.com/images/logo/logo-ticketexito.png',
            ogType: 'website',
            twitterCard: 'summary_large_image',
        },
        footerInfo:{
            facebookUrl:'',
            instagramUrl:'',
            twitterUrl:'',
            phone:'',
            waPhone:'',
            soporteEmail:'',
            copyrightText:'',
        }
    },

    // ── AWS Amplify ────────────────────────────────────────
    amplify: {
        graphqlEndpoint: 'https://connect.ticketexitotest.apps-ecualatino.dev/graphql',
        region: 'us-east-1',
        defaultAuthMode: 'apiKey' as const,
        apiKey: 'da2-i6jfrrhjp5amzkhp2gbktmv7zy',
    },

    // ── Cloudflare Turnstile ───────────────────────────────
    cloudflare: {
        turnstile_site_key: '0x4AAAAAACZumBzT7VZkWBUg',
        turnstile_secret_key: '0x4AAAAAACZumG0hYHAobfwFuCKcwi_5OXs',
    },

    // ── Google Maps ────────────────────────────────────────
    googleMaps: {
        apiKey: 'AIzaSyCLIOIl6OYYOBRFkL8px1IM3Ye6Csz4IFQ',
        libraries: ['places', 'geometry'] as string[],
        restrictions: { country: 'EC' },
        language: 'es',
        region: 'EC',
    },

    // ── PayPhone ──────────────────────────────────────────
    payphone: {
        prepareUrl: 'https://pay.payphonetodoesposible.com/api/button/Prepare',
        confirmUrl: 'https://ticketexitotest.apps-ecualatino.dev/payments/payphone/confirm',
        cancelUrl: 'https://ticketexitotest.apps-ecualatino.dev/payments/payphone/cancel',
    },
};
